import {Icon, IconName, ScalableText, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const RedeemCoinsCard = (
  props: React.PropsWithChildren<{
    title: string;
    subtitle: string;
    icon: IconName;
    className?: string;
  }>,
) => {
  return (
    <CardWrapper className={props.className}>
      {props.children}
      <CardTitleWrapper>
        <ScalableText
          weight="mediumHeavy"
          text={props.title}
          maxFontSize={32}
          scalingSensitivity={20}
        />
        <Icon asset={props.icon} size="M" />
      </CardTitleWrapper>
      <Text size="px12">{props.subtitle}</Text>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 144px;
  height: 82px;
  border-radius: 0.5rem;
  text-align: initial;
  padding: 0 16px;
`;

const CardTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
`;
